import { Vue, Component } from "vue-property-decorator";
import Carousel from '@/components/carousel/index.vue';
import RequestButtonFxd from '@/components/request-button/index.vue';
import RequestButton from '@/components/request-button/parts/request-button.vue';
import TrialButton from '@/components/trial-button/index.vue';
import FreeProducts from '@/components/products/parts/free-products.vue';

import user_module from '@/modules/user/index';

@Component({
  components: {
    Carousel,
    RequestButtonFxd,
    RequestButton,
    TrialButton,
    FreeProducts
  }
})

export default class PageLLEXE extends Vue {

  slides: any[] = [
    {
      id: 1,
      icon: 'https://rixtrema.net/larkspurexecutive/img/landing/valerib.jpg',
      description: 'Our firm can not only provide excellent plan governance but the cost sayings can be truly eye opening. Builds credibility with your strategic partners and enhances referrals. Also the support has been amazing when I have questions, response is outstanding!',
      name: 'Valeri Bishop',
      post: 'AIF'
    },
    {
      id: 2,
      icon: 'https://rixtrema.net/larkspurexecutive/img/landing/apas.jpg',
      description: 'RiXtrema is by far the best product for RIAs who want to win retirement plan business. As one prospect put it ‘this is the best presentation they have ever seen’. Since we purchased the product in July we have well over 20 solid leads and some have already closed.',
      name: 'Alexander Pasquale',
      post: 'President of the Everest Consultants, LLC'
    },
    {
      id: 3,
      icon: 'https://rixtrema.net/larkspurexecutive/img/landing/greghicks.jpg',
      description: 'I wanted to give a recommendation to the group at Rixtrema! We’ve worked together adding a few personalized features to the web site and the service has been outstanding. The web site has allowed me to double my prospecting efforts.',
      name: 'Greg Hicks',
      post: 'CRPC® Vice President – Investments',
    },


  ]

  get token(){

    return user_module.token;
  }

  scrollExplore(){

    const scrollSection: any = this.$refs.scrollSection

    if (scrollSection){
      scrollSection.scrollIntoView({behavior: 'smooth'});
    }

  }

  getTrial(){

    if (this.token){

     user_module.getTrial('LEXE');
     this.$router.push('/trial?product=LEXE');  

   } else {

     this.$router.push('/trial_logout?product=LEXE');  

   }

 }

}